import { render, staticRenderFns } from "./YDocReviewAwardBanner.vue?vue&type=template&id=76c4ae8a&scoped=true&"
import script from "./YDocReviewAwardBanner.vue?vue&type=script&setup=true&lang=ts&"
export * from "./YDocReviewAwardBanner.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./YDocReviewAwardBanner.vue?vue&type=style&index=0&id=76c4ae8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c4ae8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76c4ae8a')) {
      api.createRecord('76c4ae8a', component.options)
    } else {
      api.reload('76c4ae8a', component.options)
    }
    module.hot.accept("./YDocReviewAwardBanner.vue?vue&type=template&id=76c4ae8a&scoped=true&", function () {
      api.rerender('76c4ae8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/YDocReviewAwardBanner/YDocReviewAwardBanner.vue"
export default component.exports